import React, { useState } from 'react';
import classNames from 'classnames';
import { OrderType } from '../../../library/enums';
import { safeCallback } from '../../../library/helpers';
import styles from './order-button.module.css';
var defaultLabelMap = new Map([
    [OrderType.Ascending, 'Low to High'],
    [OrderType.Descending, 'High to Low'],
    [OrderType.Organic, 'Unsorted'],
]);
export function OrderButton(_a) {
    var _b, _c, _d, _e;
    var _f = _a.labelMap, labelMap = _f === void 0 ? defaultLabelMap : _f, _g = _a.variant, variant = _g === void 0 ? 'normal' : _g, _h = _a.defaultOrderType, defaultOrderType = _h === void 0 ? OrderType.Ascending : _h, onChange = _a.onChange;
    var _j = useState(defaultOrderType), order = _j[0], setOrder = _j[1];
    function update(typeValue) {
        setOrder(typeValue);
        safeCallback(onChange, typeValue);
    }
    function nextOrder() {
        if (order === OrderType.Ascending) {
            update(OrderType.Descending);
        }
        else if (order === OrderType.Descending) {
            update(OrderType.Organic);
        }
        else if (order === OrderType.Organic) {
            update(OrderType.Ascending);
        }
    }
    return (React.createElement("div", { onClick: function () { return nextOrder(); }, className: classNames(styles.orderButtonWrapper, styles[variant], "kplr_orderButtonWrapper") },
        React.createElement("div", { className: styles.orderButtonLabels },
            React.createElement("div", { className: styles.orderButtonLabelsInner },
                variant === 'normal' && React.createElement("label", null, "Display results"),
                React.createElement("ul", { className: styles.orderButtonDisplayList },
                    React.createElement("li", { style: { transform: "translateY(0)" }, className: classNames(styles.orderButtonDisplayListItem, (_b = {}, _b[styles.active] = order === OrderType.Ascending, _b)) }, labelMap.get(OrderType.Ascending)),
                    React.createElement("li", { style: { transform: "translateY(-14px)" }, className: classNames(styles.orderButtonDisplayListItem, (_c = {}, _c[styles.active] = order === OrderType.Descending, _c)) }, labelMap.get(OrderType.Descending)),
                    React.createElement("li", { style: { transform: "translateY(-28px)" }, className: classNames(styles.orderButtonDisplayListItem, (_d = {}, _d[styles.active] = order === OrderType.Organic, _d)) }, labelMap.get(OrderType.Organic))))),
        React.createElement("div", { className: classNames(styles.orderButtonIcon, (_e = {}, _e[styles.ascending] = order === OrderType.Ascending, _e[styles.descending] = order === OrderType.Descending, _e)) },
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null))));
}
export default OrderButton;
